import type { ReactNode } from 'react'

import styles from '../advanced-search.module.css'

export function Card ({ children }: {children: ReactNode}): JSX.Element {
  return (
    <div className={styles.card}>{children}</div>
  )
}
